
(function datePickerDirectiveDefinition() {

    'use strict';

    function datepickerWrap($rootScope) {

        return {
            restrict: 'A',
            require: '?^ngModel',
            link: function($scope, $element, attrs, ngModel) {
                // Force popup rerender whenever locale changes
                if(ngModel)
                    $rootScope.$on('$localeChangeSuccess', ngModel.$render);
            }
        };
    }

    datepickerWrap.$inject = ['$rootScope'];

    angular.module('DateTimePicker')
           .directive('uibDatepicker', datepickerWrap)
           .directive('uibDatepickerPopup', datepickerWrap);
    
    function createDatePickerFactory(small) {
        return function datePickerDirectiveFactory() {
            return {
                restrict: 'EA',
                require: 'ngModel',
                scope: {
                    ngModel: '=',
                    ngDisabled: '=',
                    ngChange: '&',
                    dayFormat: "=",
                    monthFormat: "=",
                    yearFormat: "=",
                    dayHeaderFormat: "=",
                    dayTitleFormat: "=",
                    monthTitleFormat: "=",
                    showWeeks: "=",
                    startingDay: "=",
                    yearRange: "=",
                    dateFormat: "=",
                    minDate: "=",
                    maxDate: "=",
                    enableTextInput: "=",
                    dateOptions: "=",
                    dateDisabled: "&",
                    placeholder: "@",
                    clearText: "@",
                    showClear: "@",
                    updatePromise: "=?",
                    dateLoading: "=?"
                },
                template: function (elem, attrs) {

                    function dashCase(name, separator) {
                        return name.replace(/[A-Z]/g, function (letter, pos) {
                            return (pos ? '-' : '') + letter.toLowerCase();
                        });
                    }

                    function createAttr(innerAttr, dateTimeAttrOpt) {
                        var dateTimeAttr = angular.isDefined(dateTimeAttrOpt) ? dateTimeAttrOpt : innerAttr;
                        if (attrs[dateTimeAttr]) {
                            return dashCase(innerAttr) + "=\"" + dateTimeAttr + "\" ";
                        } else {
                            return '';
                        }
                    }

                    function createFuncAttr(innerAttr, funcArgs, dateTimeAttrOpt) {
                        var dateTimeAttr = angular.isDefined(dateTimeAttrOpt) ? dateTimeAttrOpt : innerAttr;
                        if (attrs[dateTimeAttr]) {
                            return dashCase(innerAttr) + "=\"" + dateTimeAttr + "({" + funcArgs + "})\" ";
                        } else {
                            return '';
                        }
                    }

                    function createFuncAttr(innerAttr, dateTimeAttrOpt) {
                        if (attrs[dateTimeAttrOpt]) {
                            return innerAttr + "=\"" + attrs[dateTimeAttrOpt] + "\"";
                        } else {
                            return '';
                        }
                    }

                    function createEvalAttr(innerAttr, dateTimeAttrOpt, append) {
                        var dateTimeAttr = angular.isDefined(dateTimeAttrOpt) ? dateTimeAttrOpt : innerAttr;
                        if (attrs[dateTimeAttr]) {
                            return dashCase(innerAttr) + "=\"" + attrs[dateTimeAttr] + (append ? ' ' + append : '') + "\" ";
                        } else {
                            return dashCase(innerAttr) + "=\"" + (append || '') + "\" ";
                        }
                    }

                    function createAttrConcat(previousAttrs, attr) {
                        return previousAttrs + createAttr.apply(null, attr);
                    }

                    var tmpl = "<div class=\"nowrap\"><div class=\"col-xs-12 no-padding\" " +
                        createEvalAttr("ngClass", "datePartClass")
                        + " style=\"display:inline-block\">\n"
                        + "<div class=\"input-group" + (small ? ' input-group-sm\">' : '\">')
                        + "<input maxlength=\"10\" "
                        + " ng-readonly=\"!enableTextInput\" "
                        + createEvalAttr("class", "dateInputClass", 'form-control date-picker-input')
                        + createFuncAttr("tabindex", "tabindex")
                        + " type=\"text\" ng-click=\"inputClicked($event)\" is-open=\"opened\" ng-model=\"ngModel\" ng-disabled=\"ngDisabled\" datepicker-Options=\"extendedDateOptions\" datepicker-append-to-body=\"true\" " + [
                            ["minDate"],
                            ["maxDate"],
                            ["dayFormat"],
                            ["monthFormat"],
                            ["yearFormat"],
                            ["dayHeaderFormat"],
                            ["dayTitleFormat"],
                            ["monthTitleFormat"],
                            ["startingDay"],
                            ["yearRange"]
                        ].reduce(createAttrConcat, '') +
                        createFuncAttr("dateDisabled", "date: date, mode: mode") +
                        createEvalAttr("uibDatepickerPopup", "dateFormat") +
                        createEvalAttr("placeholder", "placeholder") +
                        " />\n" +
                        "<span class=\"input-group-btn date-picker-btn\">" +
                        '<a class="btn btn-default" ng-click="!ngDisabled && open($event)"><i class="glyphicon glyphicon-calendar"></i></a>' +
                        "</span>\n" +
                        "</div>\n" +
                        "</div>\n" +
                        '<span ng-if="showClear"><a href="" class="btn btn-danger" ng-click="clear()" >{{clearText || "Clear"}}</a></span>' +
                        "</div>";

                    elem.attr('tabindex', null);

                    return tmpl;
                },
                controller: [
                    '$scope', '$rootScope',
                    function ($scope, $rootScope) {

                        $scope.extendedDateOptions = angular.extend($scope.dateOptions || {}, {
                            'datePickerUpdate': '$parent.$parent.updatePromise',
                            'datePickerLoading': '$parent.$parent.dateLoading',
                        });

                        function closeOtherPickers() {
                            $scope.ignoreCloseEvent = true;
                            $rootScope.$broadcast('datetimePickerOpened');
                            $scope.ignoreCloseEvent = false;
                        };

                        // usar un evento para cerrar todos los pickers que no sean el que se está abriendo
                        $scope.$on('datetimePickerOpened', function closePickers() {
                            if (!$scope.ignoreCloseEvent) {
                                $scope.opened = false;
                            }
                        });

                        $scope.clear = function () {
                            $scope.oldModelo = $scope.ngModel;
                            $scope.ngModel = undefined;
                        };

                        $scope.restore = function () {
                            if ($scope.oldModelo && $scope.ngModel == undefined) {
                                $scope.ngModel = $scope.oldModelo;
                            } else if ($scope.ngModel == null) {
                                var date = new Date();
                                date.setHours(0);
                                date.setMinutes(0);
                                date.setSeconds(0);
                                date.setMilliseconds(0);
                                $scope.ngModel = convertLocalDateToUTCDate(date);
                            }
                        };

                        $scope.open = function open($event) {
                            $scope.restore();
                            $event.preventDefault();
                            $event.stopPropagation();
                            $scope.opened = true;
                            closeOtherPickers();
                        };
                        
                        $scope.inputClicked = function close($event) {
                            $event.preventDefault();
                            $event.stopPropagation();

                            if (!$scope.enableTextInput) {
                                $scope.open($event);
                            } else {
                                $scope.opened = false;
                                closeOtherPickers();
                            }
                        };

                    }
                ],
                link: function ($scope, element, attrs, ngModelCtrl) {
                    
                    if (attrs.ngChange) {
                        $scope.$watch('ngModel', $scope.ngChange);
                    }

                    // Los cambios del scope se pueden detectar sin problemas, pero 
                    // el error no, por eso uso el model controller del popup.
                    if ($scope.popupModelController) {
                        $scope.popupModelController.oldSetValidity = $scope.popupModelController.$setValidity;
                        $scope.popupModelController.$setValidity = function () {
                            ngModelCtrl.$setValidity.apply(ngModelCtrl, arguments);
                            $scope.popupModelController.oldSetValidity.apply(this, arguments);
                        };

                        $scope.popupModelController.oldSetDirty = $scope.popupModelController.$setDirty;
                        $scope.popupModelController.$setDirty = function () {
                            ngModelCtrl.$setDirty.apply(ngModelCtrl, arguments);
                            $scope.popupModelController.oldSetDirty.apply(this, arguments);
                        };
                    }
                }
            };
        };
    };

    angular.module("DateTimePicker")
        .directive('datePicker', createDatePickerFactory(false))
        .directive('smallDatePicker', createDatePickerFactory(true))
        .directive('uibDatepickerPopup', ['uibDatepickerPopupConfig', 'uibDateParser', function (datepickerPopupConfig, dateParser) {
            return {
                restrict: 'EA',
                require: '?^ngModel',
                priority: 100,  
                link: function (scope, element, attrs, ngModelCtrl) {

                    var dateFormat = attrs.datepickerPopup || datepickerPopupConfig.datepickerPopup;
                    attrs.$observe('uibDatepickerPopup', function (value, oldValue) {
                        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;

                        if (newDateFormat !== dateFormat) {
                            dateFormat = newDateFormat;
                        }
                    });

                    ngModelCtrl.$formatters.push(function (value) {
                        if (value && typeof (value) === 'string') {
                            value = dateParser.parse(value, dateFormat) || new Date(value);
                        }
                        return value;
                    });

                    // el validator de date no toma un date parseable ocn el constructor como válido
                    ngModelCtrl.$validators.date = function validator(modelValue, viewValue) {
                        var value = modelValue || viewValue;

                        if (!attrs.ngRequired && !value) {
                            return true;
                        }

                        if (angular.isNumber(value)) {
                            value = new Date(value);
                        }
                        if (!value) {
                            return true;
                        } else if (angular.isDate(value) && !isNaN(value)) {
                            return true;
                        } else if (angular.isString(value)) {
                            // el validator de date no toma un date parseable ocn el constructor como válido
                            var date = dateParser.parse(value, dateFormat) || new Date(value);
                            return !isNaN(date);
                        } else {
                            return false;
                        }
                    };

                    // agrego un validador para el viewValue ya que si el date picker tiene habilitado el text input se
                    // aceptan valores a medias.
                    ngModelCtrl.$validators.date2 = function validator(modelValue, viewValue) {
                        if (viewValue && angular.isString(viewValue)) {
                            var date = dateParser.parse(viewValue, dateFormat);
                            return date !== undefined;
                        }
                        return true;
                    };

                    ngModelCtrl.$viewChangeListeners = [function () {
                        var date = dateParser.parse(ngModelCtrl.$viewValue, dateFormat, scope.date) || new Date(ngModelCtrl.$viewValue);
                        if (isNaN(date)) {
                            scope.date = '';
                        } else {
                            scope.date = date;
                        }
                    }];

                    // coloco el controller del ngModel en el scope ya que el smallDatePicker o el datePicker lo usarán.
                    scope.popupModelController = ngModelCtrl;
                }
            };
        }])
        // Este es un fix para cuando se ingresa una fecha inválida.
        .directive('uibDatepicker', [function () {
            return {
                restrict: 'EA',
                require: ['uibDatepicker', '?^ngModel'],
                priority: 100,  // ejecuta despues del datepicker de uibootstrap
                link: function (scope, element, attrs, ctrls) {
                    var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
                    
                    // reemplazo el render porque sino se muestra una excepción
                    datepickerCtrl.render = function () {
                        
                        if (ngModelCtrl.$viewValue) {
                            var date = new Date(ngModelCtrl.$viewValue),
                                isValid = !isNaN(date) && (date && date.getTime && !isNaN(date.getTime()));

                            if (isValid) {
                                this.activeDate = date;
                            }

                            ngModelCtrl.$setValidity('date', isValid);  
                        }
                        this.refreshView();
                    };

                }
            };
        }]);

    
})();
